exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "\n\n.PatientInfo_container_dVe6i {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n  -webkit-justify-content: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  color: #fff;\n  -webkit-transform: translateY(6.5rem);\n      -ms-transform: translateY(6.5rem);\n          transform: translateY(6.5rem);\n}\n\n.PatientInfo_divider_TtJjM {\n  background-color: #fff;\n  height: 1rem;\n  padding: 0 0.0625rem;\n  margin: 0 1rem;\n}\n.PatientInfo_info_3ac2q {\n  text-align: center;\n}\n\n/* Small Devices, Tablets */\n@media only screen and (min-width: 768px) {\n  .PatientInfo_container_dVe6i {\n    -webkit-transform: translateY(4.75rem);\n        -ms-transform: translateY(4.75rem);\n            transform: translateY(4.75rem);\n  }\n}\n", ""]);

// exports
exports.locals = {
	"container": "PatientInfo_container_dVe6i",
	"divider": "PatientInfo_divider_TtJjM",
	"info": "PatientInfo_info_3ac2q"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"importLoaders":1,"localIdentName":"[name]_[local]_[hash:base64:5]"}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/components/PatientInfo.css
// module id = 946
// module chunks = 0